import React, { Component } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap"
import { initField } from "../../../lib/form-builder"
import { email, nonEmpty } from "../../../lib/validators"
import FieldGroup from "../../FieldGroup"
import SelectForm from "../../SelectForm"
import PropTypes from "prop-types"
import ProcessesStatus from "../../fragments/ProcessesStatus"

import FontAwesome from "react-fontawesome"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"

class UserForm extends Component {

  constructor(props) {

    super(props)

    const { user } = this.props,
    isNew = !user || !user.id

    this.state = {
      ...initField(this, 'username', isNew ? '' : user.username, email),
      ...initField(this, 'name', isNew ? '' : user.name, nonEmpty),
      ...initField(this, 'userRole', isNew ? '' : user.userRole, nonEmpty),
      ...initField(this, 'locale', isNew ? 'en' : user.locale, nonEmpty),
      isNew,
    }
  }

  componentDidMount() {

    const { isNew, username, name, userRole } = this.state
    if(!isNew) {
      username.validationCurrentValue()
      name.validationCurrentValue()
    }
    userRole.validationCurrentValue()
  }

  valid() {

    const { username, name, userRole } = this.state
    return (
      username.validation &&
      username.validation.valid &&
      name.validation &&
      name.validation.valid &&
      userRole.validation &&
      userRole.validation.valid
    )
  }

  saveClicked = () => {

    if(this.valid()) {

      const { onSaveClicked, user } = this.props,
      { username, name, userRole, locale } = this.state
      onSaveClicked({
        id: user != null ? user.id : null,
        username: username.value,
        name: name.value,
        userRole: userRole.value,
        locale: locale.value
      })
    }
  }

  render() {

    const { user, userRoles, error, running, success, resetUserPassword } = this.props,
    { username, name, userRole, isNew } = this.state,
    dataBreadCrumbs = [{ url: '/users', title: 'Users' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ user ? user.name : 'New' } data={ dataBreadCrumbs } />

        <Col smOffset={3} md={6} className="simple-form margin-bottom-40">
          <Form>

            <FieldGroup
              id="username"
              type="email"
              label="Email address"
              placeholder="Enter email"
              value={ username.value }
              onChange={ username.onChange }
              validationState={ username.validation }
              validationMessage="Please enter a valid username"
            />

            <FieldGroup
              id="name"
              type="text"
              label="Name"
              placeholder="Enter name"
              value={ name.value }
              onChange={ name.onChange }
              validationState={ name.validation }
              validationMessage="Please enter a valid name"
            />

            <SelectForm
              id="role"
              label="User role"
              items={ userRoles }
              value={ userRole.value }
              onChange={ userRole.setValue }
            />

            { user && user.offlineCode &&
              <FormGroup controlId="offlineCode">
                <ControlLabel>Offline code</ControlLabel>
                <FormControl value={ user.offlineCode } disabled />
              </FormGroup>
            }
          </Form>

          <ProcessesStatus error={ error } running={ running } success={ success } />

          <div className="align-right">
            <Button
              bsStyle="primary"
              onClick={ this.saveClicked }
              disabled={ !this.valid() || running }>
              <FontAwesome name='save' /> { isNew ? "Create new user" : "Save user"}
            </Button>

            { !isNew && 
              <span> &nbsp;
                <Button
                  bsStyle="danger"
                  disabled={ running }
                  onClick={ resetUserPassword }>
                  Reset user Password
                </Button>
              </span>
            }
          </div>
        </Col>
      </div>
    )
  }
}

UserForm.propTypes = {
  onSaveClicked: PropTypes.func.isRequired
}

export default UserForm



// WEBPACK FOOTER //
// ./src/components/Users/UserForm/index.js